import { render, staticRenderFns } from "./DetailA.vue?vue&type=template&id=40208b98&"
import script from "./DetailA.vue?vue&type=script&lang=js&"
export * from "./DetailA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports